import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import SweetAlert from "react-bootstrap-sweetalert";
import { showLoaderStateActions } from "./store";

import CircularProgress from "@material-ui/core/CircularProgress";
import PropagateLoader from "react-spinners/PropagateLoader";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "25px",
    height: "25px",
    filter: "brightness(0) invert(1)",
  },
  loader: {
    display: "flex",
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
}));

const Loader = (props) => {
//   const [isLoading, setIsLoading] = useState(true);
  const classes = useStyles();
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.showLoaderState.isLoading);


  const onConfirm = () => {
    // setIsLoading(false);
  };

  const onCancel = () => {
    dispatch(showLoaderStateActions.addState(false));
  };

  return (
    <>
      {/* {isLoading && (
        <SweetAlert
        showCloseButton = {true}
        showConfirm = {false}
        show = {isLoading}
        // timeout = {1000}
          title="Here's a message!"
          onConfirm={onConfirm}
          onCancel={onCancel}
        />
      )} */}

      <SweetAlert
        closeOnClickOutside={false}
        showConfirm={false}
        onCancel={onCancel}
        show={isLoading}
        style={{flexDirection:'row', width: "250px", borderRadius:"5px"}}
        title=""
        onConfirm={()=>{}}
        onCancel={()=>{}}
      >
        <div className={classes.loader}>
           <PropagateLoader color='blue'  />
        </div>
      </SweetAlert>
    </>
  );
};

export default Loader;
